import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockKeyholeIcon, EyeOffIcon, UsersIcon } from 'lucide-react';
const trustSignals = [{
  icon: ShieldCheckIcon,
  title: "You're in control",
  description: 'You decide how and when to settle up, your own way.'
}, {
  icon: EyeOffIcon,
  title: 'Your data stays yours',
  description: 'We protect your data and keep it private.'
}, {
  icon: LockKeyholeIcon,
  title: 'Private by design',
  description: 'Your group expenses stay private.'
}, {
  icon: UsersIcon,
  title: 'You control who sees each kitty',
  description: 'Choose who can see each kitty and its shared expenses.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: 'easeOut'
    }
  }
};
export function TrustSecurity() {
  return <section className="py-24 lg:py-32 bg-gray-950 text-white relative overflow-hidden" data-id="element-243" data-mp="3vooryey4z7md">
      {/* Subtle glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-244" data-mp="4inejzqp81xk">
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[400px] bg-kitty-yellow/[0.04] rounded-full blur-3xl" data-id="element-245" data-mp="4frea4rdp15y" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246" data-mp="3rmbndtv4lfr6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16 lg:mb-20" data-id="element-247" data-mp="3roob6nnkekc5">
          <div className="inline-flex items-center gap-2 bg-white/[0.06] border border-white/[0.1] rounded-full px-4 py-1.5 mb-6" data-id="element-248" data-mp="egbjtjlxkrtz">
            <ShieldCheckIcon className="w-4 h-4 text-kitty-yellow" data-id="element-249" data-mp="125mb8ahe59vg" />
            <span className="text-sm font-medium text-gray-300" data-id="element-250" data-mp="16wm7ddiornww">
              Security & Trust
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight mb-5" data-id="element-251" data-mp="1gsuulykuslii">
            You stay in control of{' '}
            <span className="text-kitty-yellow" data-id="element-252" data-mp="1bu9qho2hdhos">your money.</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-xl mx-auto leading-relaxed" data-id="element-253" data-mp="16t3vtkp9fkcm">
            Today, KittyPot keeps your group expenses clear and lets everyone settle up directly, your own way.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-id="element-254" data-mp="xvtky0gctx88">
          {trustSignals.map(item => <motion.div key={item.title} variants={itemVariants} className="rounded-2xl bg-white/[0.04] border border-white/[0.08] p-6 lg:p-8 text-center flex flex-col items-center" data-id="element-255" data-mp="j5cjwi7mt9bv">
              <div className="w-12 h-12 rounded-2xl bg-kitty-yellow/10 flex items-center justify-center mb-5" data-id="element-256" data-mp="a4ega113v3tt">
                <item.icon className="w-6 h-6 text-kitty-yellow" data-id="element-257" data-mp="2ls16q0pi76lx" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-258" data-mp="2pste0oetf1fk">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed" data-id="element-259" data-mp="2uroa2s1smmhm">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}